export default "__VITE_ASSET__D5Yj9NWQ__"